import { ReactNode, useCallback, useEffect, useState } from "react";

import { ProductsContext } from "@/contexts/productsContext";
import { CareProducts, TestProducts } from "@/pages/shopAll/types";
import { productsService } from "@/services/products";

export const ProductsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [allProducts, setAllProducts] = useState<{
    care_products?: CareProducts;
    test_products?: TestProducts;
  }>();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);

  const fetchAllProducts = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await productsService.fetchAllProducts();
      setAllProducts(response.data);
      setError(null);
    } catch (error: any) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllProducts();
  }, [fetchAllProducts, refetch]);

  const refetchAllProducts = () => {
    setRefetch((prev) => !prev);
  };

  return (
    <ProductsContext.Provider
      value={{
        allProducts,
        error,
        isLoading,
        refetchAllProducts,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
